// MyKisan.jsx
// subscription CTA, farmer marketplace preview, and contribution history mock.

import React, { useState } from "react";
import { motion } from "framer-motion";

export default function MyKisan() {
  const [activeTab, setActiveTab] = useState("overview");
  const [showEnrollModal, setShowEnrollModal] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedFarmer, setSelectedFarmer] = useState(null);
  const [contributions] = useState([
    { id: 1, farmer: "Ramesh, Village: Kheri", purpose: "Crop Damage", amt: 3, date: "2025-09-12" },
    { id: 2, farmer: "Sita, Village: Bahera", purpose: "Medical", amt: 12, date: "2025-08-02" },
  ]);

  const farmers = [
    { id: 1, name: "Ramesh", village: "Kheri", district: "Raipur", state: "Chhattisgarh", pin: "492001" },
    { id: 2, name: "Sita", village: "Bahera", district: "Bilaspur", state: "Chhattisgarh", pin: "495001" },
    { id: 3, name: "Raj", village: "Dharam", district: "Dhamtari", state: "Chhattisgarh", pin: "493773" },
  ];

  const filtered = farmers.filter((f) => {
    const q = search.trim().toLowerCase();
    if (!q) return true;
    return (
      f.name.toLowerCase().includes(q) ||
      f.village.toLowerCase().includes(q) ||
      f.district.toLowerCase().includes(q) ||
      f.state.toLowerCase().includes(q) ||
      f.pin.includes(q)
    );
  });

  function handleSubscribe(farmer) {
    setSelectedFarmer(farmer);
    // In production, open payment flow or subscription modal
    alert(`Subscribed ₹12/month. 25% will go to ${farmer.name}. (Mock)`);
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-900 via-emerald-800 to-emerald-900 text-white p-4">
      <header className="mx-auto">
        <div className="flex items-center justify-between p-4 bg-white/10 backdrop-blur-sm border-b border-emerald-200/30 shadow-sm">
        <div>
            <h1 className="text-left text-2xl font-bold leading-tight text-white">MyKisan</h1>
            <p className="text-sm text-emerald-200/80">Support farmers. Direct. Digital.</p>
            </div>
            <button
            onClick={() => setShowEnrollModal(true)}
            className="bg-emerald-600 hover:bg-emerald-500 active:bg-emerald-700 transition-colors text-white w-36 px-4 py-2 rounded-md text-sm shadow-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
            >
            Enroll Free
            </button>
        </div>

        {/* Tabs */}
        <nav className="mt-4 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-2 pb-2">
            {[
                { id: "overview", label: "📊 Overview" },
                { id: "engage", label: "💬 Engage" },
                { id: "market", label: "🛒 Agri Marketplace" },
                { id: "impact", label: "🌱 My Impact" },
            ].map((t) => (
                <button
                key={t.id}
                onClick={() => setActiveTab(t.id)}
                className={`px-3 py-2 rounded-full text-sm font-medium transition-colors ${
                    activeTab === t.id ? "bg-white/10" : "bg-white/5 hover:bg-white/10"
                }`}
                >
                {t.label}
                </button>
            ))}
        </nav>
      </header>

      <main className="mx-auto mt-4 space-y-4 pb-20">
        {activeTab === "overview" && (
          <section>
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35 }}
              className="bg-white/6 rounded-2xl p-4"
            >
              <h2 className="text-lg font-semibold">Why MyKisan?</h2>
              <p className="mt-2 text-sm text-emerald-100/90">
                A digital movement to support marginal and small farmers across India for additional
                income, crop damage relief, medical &amp; emergency needs. Powered by citizen
                subscriptions and a transparent allocation engine.
              </p>

              <div className="mt-4 grid grid-cols-3 gap-2">
                <StatCard label="Target Farmers" value="15 Cr+" />
                <StatCard label="Subscription" value="₹12 / month" />
                <StatCard label="Farmer Share" value="25%" />
              </div>

              <div className="mt-4 flex gap-2">
                <button
                  onClick={() => setActiveTab("engage")}
                  className="flex-1 bg-emerald-600/90 hover:bg-emerald-500 py-2 rounded-lg text-sm font-medium shadow"
                >
                  Suggest a Farmer
                </button>
                <button
                  onClick={() => setActiveTab("market")}
                  className="flex-1 bg-white/6 py-2 rounded-lg text-sm font-medium"
                >
                  Visit Marketplace
                </button>
              </div>
            </motion.div>
          </section>
        )}

        {activeTab === "engage" && (
          <section>
            <div className="bg-white/6 rounded-2xl p-4 space-y-3">
              <h3 className="text-lg font-semibold">Find or Suggest a Farmer</h3>

              <div className="flex gap-2">
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search name, village, district or PIN"
                  className="flex-1 bg-white/5 placeholder-emerald-200/60 rounded-lg px-3 py-2 text-sm outline-none"
                />
                <button
                  onClick={() => setSearch("")}
                  className="bg-white/5 px-3 py-2 rounded-lg text-sm">
                  Clear
                </button>
              </div>

              <div className="mt-2 space-y-2">
                {filtered.map((f) => (
                  <motion.div
                    key={f.id}
                    whileHover={{ scale: 1.02 }}
                    className="bg-white/4 rounded-xl p-3 flex items-center justify-between"
                  >
                    <div>
                      <div className="text-sm font-semibold">{f.name} — {f.village}</div>
                      <div className="text-xs text-emerald-100/70">{f.district}, {f.state} · {f.pin}</div>
                    </div>
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => handleSubscribe(f)}
                        className="text-sm bg-emerald-600/90 px-3 py-1 rounded-md font-medium"
                      >
                        Subscribe
                      </button>
                      <button
                        onClick={() => setSelectedFarmer(f)}
                        className="text-xs bg-white/6 px-2 py-1 rounded-md"
                      >
                        Details
                      </button>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </section>
        )}

        {activeTab === "market" && (
          <section>
            <div className="bg-white/6 rounded-2xl p-4">
              <h3 className="text-lg font-semibold">Farmer Marketplace (Preview)</h3>
              <p className="text-sm mt-2 text-emerald-100/80">Buy produce or crafts directly and support livelihoods.</p>

              <div className="mt-3 grid grid-cols-2 gap-3">
                <MarketCard title="A2 Ghee Jar" seller="Sita - Bahera" price="₹220" />
                <MarketCard title="Millet Pack" seller="Ramesh - Kheri" price="₹120" />
                <MarketCard title="Honey Jar" seller="Raj - Dharam" price="₹180" />
                <MarketCard title="Handloom Scarf" seller="Seema - Bilaspur" price="₹299" />
              </div>

              <div className="mt-4">
                <button className="w-full py-2 rounded-lg bg-emerald-600/90 font-medium">Open Marketplace</button>
              </div>
            </div>
          </section>
        )}

        {activeTab === "impact" && (
          <section>
            <div className="bg-white/6 rounded-2xl p-4">
              <h3 className="text-lg font-semibold">My Contribution Impact</h3>
              <p className="text-sm mt-2 text-emerald-100/80">Track your subscriptions and direct contributions.</p>

              <div className="mt-3 space-y-2">
                {contributions.map((c) => (
                  <div key={c.id} className="bg-white/5 rounded-lg p-3 flex justify-between items-center">
                    <div>
                      <div className="text-sm font-semibold">{c.farmer}</div>
                      <div className="text-xs text-emerald-100/70">{c.purpose} • {c.date}</div>
                    </div>
                    <div className="text-sm font-semibold">₹{c.amt}</div>
                  </div>
                ))}
              </div>

              <div className="mt-4 text-sm text-emerald-200/80">Total Impact: <span className="font-semibold">₹{contributions.reduce((s, c) => s + c.amt, 0)}</span></div>
            </div>
          </section>
        )}
      </main>

      {/* Enroll Modal */}
      {showEnrollModal && (
        <div className="fixed inset-0 z-40 flex items-end sm:items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/60" onClick={() => setShowEnrollModal(false)}></div>

          <motion.div
            initial={{ y: 60, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.25 }}
            className="relative z-50 w-full max-w-md bg-white/6 rounded-2xl p-4"
          >
            <h4 className="text-lg font-semibold">Free Enrollment</h4>
            <p className="text-sm mt-2 text-emerald-100/80">Register on Think5Whys and get your unique Think5Whys code to enroll in MyKisan.</p>

            <form className="mt-3 space-y-3" onSubmit={(e) => { e.preventDefault(); alert('Registered (mock). Your Think5Whys code: T5W-XXXX'); setShowEnrollModal(false); }}>
              <input className="w-full bg-white/5 rounded-md px-3 py-2 text-sm outline-none" placeholder="Full name" required />
              <input className="w-full bg-white/5 rounded-md px-3 py-2 text-sm outline-none" placeholder="Mobile number" required />

              <div className="flex gap-2">
                <button type="submit" className="flex-1 py-2 rounded-lg bg-emerald-600/90">Register</button>
                <button type="button" onClick={() => setShowEnrollModal(false)} className="flex-1 py-2 rounded-lg bg-white/6">Cancel</button>
              </div>
            </form>
          </motion.div>
        </div>
      )}

      {/* Details Drawer (simple) */}
      {selectedFarmer && (
        <div className="fixed inset-0 z-30 flex items-end sm:items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/50" onClick={() => setSelectedFarmer(null)}></div>
          <motion.div initial={{ y: 40 }} animate={{ y: 0 }} className="relative z-40 w-full max-w-md bg-white/6 rounded-2xl p-4">
            <div className="flex justify-between items-start">
              <div>
                <h4 className="text-lg font-semibold">{selectedFarmer.name}</h4>
                <div className="text-xs text-emerald-100/70">{selectedFarmer.village}, {selectedFarmer.district} • {selectedFarmer.pin}</div>
              </div>
              <button onClick={() => setSelectedFarmer(null)} className="text-sm bg-white/6 px-2 py-1 rounded">Close</button>
            </div>

            <div className="mt-3 space-y-2 text-sm text-emerald-100/80">
              <p><strong>Suggested support:</strong> Additional Income / Crop Damage / Emergency</p>
              <p><strong>How to help:</strong> Subscribe to Gaon2Global (₹12/month) or buy directly from marketplace.</p>
            </div>

            <div className="mt-4 flex gap-2">
              <button onClick={() => handleSubscribe(selectedFarmer)} className="flex-1 py-2 rounded-lg bg-emerald-600/90">Subscribe ₹12</button>
              <button onClick={() => { alert('Open marketplace - mock'); }} className="flex-1 py-2 rounded-lg bg-white/6">Buy from Marketplace</button>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
}

function StatCard({ label, value }) {
  return (
    <div className="bg-emerald-800/30 rounded-lg p-3 text-center">
      <div className="text-xs text-emerald-100/80">{label}</div>
      <div className="text-sm font-semibold mt-1">{value}</div>
    </div>
  );
}

function MarketCard({ title, seller, price }) {
  return (
    <div className="bg-white/4 rounded-xl p-3 flex flex-col gap-2">
      <div className="h-24 rounded-md bg-white/6 flex items-center justify-center">Image</div>
      <div className="text-sm font-semibold">{title}</div>
      <div className="text-xs text-emerald-100/70">{seller}</div>
      <div className="mt-2 flex items-center justify-between">
        <div className="text-sm font-semibold">{price}</div>
        <button className="text-xs bg-emerald-600/90 px-2 py-1 rounded">Buy</button>
      </div>
    </div>
  );
}
